import React, { createContext, useContext, useState } from "react";

const DEFAULT = { km: null, mode: "point_to_point", hours: 2, deposit: false };
const TripContext = createContext({ trip: DEFAULT, setTrip: () => {} });

export const TripProvider = ({ children }) => {
  const [trip, setTrip] = useState(DEFAULT);
  return <TripContext.Provider value={{ trip, setTrip }}>{children}</TripContext.Provider>;
};

export const useTrip = () => useContext(TripContext);
